<template>
  <div class="page-loading" v-if="isLoading">
    <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
  </div>
  <div class="container-fluid">
    <header class="main-header">
      <h1 class="main-title">Toevoegen vrije dag</h1>
    </header>
    <form @submit.prevent="formSubmit">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-8">
          <div class="card gebruikers-beheer">
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-12">
                  <label for="name">Feestdag <span class="required">*</span></label>
                  <input type="text" class="form-control" id="name" v-model="newFreeDay.name"
                    :class="{ 'is-invalid': v$.newFreeDay.name.$error }" placeholder="Naam van de feestdag" />
                  <div class="invalid-feedback" v-if="v$.newFreeDay.name.$error">
                    Dit veld is verplicht.
                  </div>
                </div>
                <div class="col-md-12">
                  <label for="date">Datum <span class="required">*</span></label>
                  <input type="date" class="form-control" id="date" v-model="newFreeDay.date"
                    :class="{ 'is-invalid': v$.newFreeDay.date.$error }" />
                  <div class="invalid-feedback" v-if="v$.newFreeDay.date.$error">
                    Dit veld is verplicht.
                  </div>
                </div>
                <div class="col-md-12">
                  <label for="freeDay">Vrije dag</label>
                  <div class="form-check">
                    <input class="form-check-input secondary-checkbox" type="checkbox" id="freeDay"
                      v-model="newFreeDay.freeDay" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'AddFreeDays',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      newFreeDay: {
        name: '',
        date: '',
        freeDay: true
      }
    }
  },
  validations() {
    return {
      newFreeDay: {
        name: { required },
        date: { required }
      }
    }
  },
  methods: {
    formSubmit() {
      this.v$.$validate()
      if (!this.v$.$error) {
        this.saveFreeDay()
      }
    },
    saveFreeDay() {
      this.isLoading = true;
      this.$axiosInstance.post(`${process.env.VUE_APP_API}/Holidays/create-custom`, this.newFreeDay)
        .then(response => {
          if (response.data.status === 400) {
            this.errors = response.data.errors;
            this.$toast.open({
              message: "Er zijn één of meer validatiefouten opgetreden.",
              type: 'error',
              position: 'top-right',
              duration: 5000
            });
          } else {
            this.$toast.open({
              message: 'Vrije dag succesvol toegevoegd.',
              type: 'success',
              position: 'top-right',
              duration: 5000
            });
            this.$router.push('/vrijedagen');
          }
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.$toast.open({
            message: 'Vrije dag kon niet toegevoegd worden. Probeer het a.u.b. opnieuw.',
            type: 'error',
            position: 'top-right',
            duration: 5000
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.required {
  color: red;
}

.actions {
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    min-width: 7.5rem;
  }
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  color: #dc3545;
}
</style>